import { DEFAULT_PROMPTBOOK_NAME } from "@/constants";
import { renameResource } from "@/features/Resources/actions/renameResource";
import { api } from "@/services/api/createAPI";
import { queryClient } from "@/services/react-query/queryClient";
import { getAuthToken } from "@/services/supabase/auth/actions/getAuthToken";
import { disableAutoRename } from "./disableAutoRename";

export const renamePromptbook = async (promptbookId: string, promptbook: string) => {
  const promptbookData = queryClient.getQueryData(["promptbooks", promptbookId]);
  const autoRename = (promptbookData as any)?.auto_rename;

  if (!autoRename) {
    return;
  }

  const token = await getAuthToken();
  const { data } = await api(token).post("/api/rename/promptbook", {
    promptbook,
  });

  await renameResource(promptbookId, data?.name || DEFAULT_PROMPTBOOK_NAME);
  await disableAutoRename(promptbookId);

  queryClient.setQueryData(["promptbooks", promptbookId], {
    ...queryClient.getQueryData(["promptbooks", promptbookId]),
    name: data?.name || DEFAULT_PROMPTBOOK_NAME,
    auto_rename: false,
  });

  return data.name as string;
};
